/* eslint-disable indent */
/* eslint-disable camelcase */
import store from '../../store'
import { setFreightScores } from '../slices/criteriaSelection/freight'
import {
  CURB_LANE_WIDTH,
  CURB_LANE_WIDTH_ADJUSTMENTS,
  CURB_LANE_WIDTH_VALUES,
  SPECIAL_CONSIDERATIONS
} from '../constants/freight'
import { NA } from '../constants/scores'

export function calculateFreightScore(field) {
  const { freight, modalTiers } = store.getState()
  const { Freight: FTier } = modalTiers
  const {
    curb_lane_width,
    special_considerations,
    curb_lane_width_adjustments
  } = freight

  // If Freight Tier is 0 or NA , do not calculate score
  // Every score is NA
  if (FTier === 0) {
    for (const key of Object.keys(freight)) {
      store.dispatch(
        setFreightScores({
          field: key,
          value: NA
        })
      )
    }
    return
  }

  function calculateCurbLaneWidth() {
    curb_lane_width === CURB_LANE_WIDTH_VALUES[2]
      ? store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 3 }))
      : curb_lane_width === CURB_LANE_WIDTH_VALUES[3]
      ? store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 4 }))
      : curb_lane_width === CURB_LANE_WIDTH_VALUES[1]
      ? store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 2 }))
      : store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 1 }))
  }

  function calculateCurbLaneWidthWithAdjustments() {
    curb_lane_width === CURB_LANE_WIDTH_VALUES[2]
      ? store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 2 }))
      : curb_lane_width === CURB_LANE_WIDTH_VALUES[3]
      ? store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 3 }))
      : curb_lane_width === CURB_LANE_WIDTH_VALUES[1]
      ? store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 1 }))
      : store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: 1 }))
  }

  if (field === CURB_LANE_WIDTH && curb_lane_width) {
    if (curb_lane_width_adjustments.length && curb_lane_width) {
      calculateCurbLaneWidthWithAdjustments()
    } else if (!curb_lane_width_adjustments.length && curb_lane_width) {
      calculateCurbLaneWidth()
    }
  } else if (field === CURB_LANE_WIDTH_ADJUSTMENTS) {
    if (curb_lane_width_adjustments.length && curb_lane_width) {
      calculateCurbLaneWidthWithAdjustments()
    } else if (!curb_lane_width_adjustments.length && curb_lane_width) {
      calculateCurbLaneWidth()
    }
  } else if (field === SPECIAL_CONSIDERATIONS) {
    special_considerations.length === 2
      ? store.dispatch(setFreightScores({ field, value: 3 }))
      : store.dispatch(setFreightScores({ field, value: 1 }))
  } else if (field === CURB_LANE_WIDTH && !curb_lane_width) {
    store.dispatch(setFreightScores({ field: CURB_LANE_WIDTH, value: NA }))
  }
}
